import { createSelector } from '@reduxjs/toolkit';
import { RootStateType } from 'App/store';

export const getShippingRestrictionsData = (state: RootStateType) =>
  state.shipping.deliveryMethods.shippingRestrictions.list.data;

const getShippingRestrictionsListStatus = (state: RootStateType) =>
  state.shipping.deliveryMethods.shippingRestrictions.list.status;

export const getShippingRestrictionsStatus = createSelector(
  [getShippingRestrictionsListStatus],
  (status) => ({
    isLoading: status === 'loading',
    isSuccess: status === 'success',
    isError: status === 'error',
    isIdle: status === 'idle',
  }),
);

export const getShippingRestrictionDetail = (state: RootStateType) =>
  state.shipping.deliveryMethods.shippingRestrictions.detail.data;

const getShippingRestrictionDetailStatusRaw = (state: RootStateType) =>
  state.shipping.deliveryMethods.shippingRestrictions.detail.status;

export const getShippingRestrictionDetailStatus = createSelector(
  [getShippingRestrictionDetailStatusRaw],
  (status) => ({
    isLoading: status === 'loading',
    isSuccess: status === 'success',
    isError: status === 'error',
    isIdle: status === 'idle',
  }),
);

export const getCreateShippingRestrictionStatus = (state: RootStateType) =>
  state.shipping.deliveryMethods.shippingRestrictions.create.status;

export const getUpdateShippingRestrictionStatus = (state: RootStateType) =>
  state.shipping.deliveryMethods.shippingRestrictions.update.status;

export const getDeleteShippingRestrictionStatus = (state: RootStateType) =>
  state.shipping.deliveryMethods.shippingRestrictions.delete.status;

export const getHasShippingRestrictions = createSelector(
  [getShippingRestrictionsData],
  (data) => !!data && data.length > 0,
);

export const getShippingRestrictionsCount = createSelector(
  [getShippingRestrictionsData],
  (data) => data?.length || 0,
);
